import { STORE_CODES, type StoreCode } from "@nova-ai/shared"

import { Combobox } from "../ui/combobox"

const STORE_OPTIONS = STORE_CODES.map((code) => ({ value: code, label: code }))

function toStoreCode(value: string): StoreCode | undefined {
  return STORE_CODES.find((code) => code === value)
}

type ProductStoreSelectProps = {
  id?: string
  value: StoreCode
  onChange: (store: StoreCode) => void
  className?: string
}

/** Shared store context control for product browse and detail surfaces. */
export function ProductStoreSelect({ id, value, onChange, className }: ProductStoreSelectProps) {
  return (
    <Combobox
      aria-label="Store"
      id={id}
      options={STORE_OPTIONS}
      value={value}
      searchPlaceholder="Search stores…"
      emptyMessage="No stores"
      onChange={(nextValue) => {
        const store = toStoreCode(nextValue ?? "")
        if (store !== undefined) {
          onChange(store)
        }
      }}
      className={className}
    />
  )
}
